module.exports = __webpack_public_path__ + "assets/img/skin_1.194e0766.jpg";